function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import TabsComponent from "/components/core/tabs/tabs-component";
import TabComponent from "/components/core/tabs/tab/tab-component";
import { ALIGN_TYPES } from "constants/align-types";
import { getTabsInfo } from "./tabs";
import { withGenericConfig } from "/contexts/generic-config-context";
import { StyledTemplatePageTabs } from "./template-page-tabs.scss";
const TemplatePageTabs = (props)=>{
    const { templateData, translate, tabsMetadata } = props;
    const renderTabs = useMemo(()=>{
        return getTabsInfo(tabsMetadata).map((tabInfo)=>{
            const { component: ContentComponent } = tabInfo, moreTabContentProps = _object_without_properties(tabInfo, [
                "component"
            ]);
            const { titleKey } = moreTabContentProps;
            return /*#__PURE__*/ _jsx(TabComponent, {
                label: translate(titleKey),
                labelTranslationKey: titleKey,
                useSmallLabels: true,
                color: "dodger-blue",
                children: /*#__PURE__*/ _jsx(ContentComponent, _object_spread({
                    templateData: templateData
                }, moreTabContentProps))
            }, titleKey);
        });
    }, [
        tabsMetadata,
        templateData,
        translate
    ]);
    return /*#__PURE__*/ _jsx(StyledTemplatePageTabs, {
        className: "template-page-tabs",
        children: /*#__PURE__*/ _jsx(TabsComponent, {
            autoTransition: false,
            role: "tabpanel",
            className: "template-page-tabs-component",
            tabsAlign: ALIGN_TYPES.LEFT,
            children: renderTabs
        })
    });
};
export default withGenericConfig(TemplatePageTabs);
